import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxDateBoxModule,
  DxFormModule,
  DxSelectBoxModule,
  DxTagBoxModule,
  DxTemplateModule,
  DxTextBoxModule,
  DxToastModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { ConfigService } from 'src/app/services/config.service';
import { ContactService } from 'src/app/services/contact.service';
import { GridConnectionService } from 'src/app/services/grid-connection.service';
import { AppGlobals } from '../../app.globals';
import { GpdButtonComponent } from '../gpd-button/gpd-button.component';

import { SearchableDropdownDirective } from '../../directives/searchable-dropdown.directive';
@Component({
    selector: 'app-contacts-add-person-inline',
    imports: [
        CommonModule,
        DxFormModule,
        DxTagBoxModule,
        DxTemplateModule,
        DxToastModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxDateBoxModule,
        DxSelectBoxModule,
        GpdButtonComponent,
        SearchableDropdownDirective,
    ],
    templateUrl: './contacts-add-person-inline.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./contacts-add-person-inline.component.css']
})
export class ContactsAddPersonInlineComponent implements OnInit {
  @ViewChild('personForm') personForm;

  type: any = '';
  message: any = '';
  toastVisible: boolean = false;

  formData = {
    id: null,
    title: null,
    salutation: null,
    firstname: null,
    lastname: null,
    address: null,
    city: null,
    zipcode: null,
    country: null,
    countryId: null,
    stateId: null,
    phonePrivate: null,
    phoneCompany: null,
    phoneMobile: null,
    fax: null,
    email: null,
    birthDate: null,
    note: null,
    tags: null,
  };

  contactTags: any;
  salutations = [{ name: 'Herr' }, { name: 'Frau' }];
  countriesByLanguageList: any = [];

  @Output() onSubmit = new EventEmitter<any>();
  @Output() onAbort = new EventEmitter<any>();

  constructor(
    private configService: ConfigService,
    private contactService: ContactService,
    private gridConnectionService: GridConnectionService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.contactTags = await this.configService.loadContactTags();
    this.getCountriesByLanguage();
  }

  handleSubmitButton(event: any): void {
    const result = this.personForm.instance.validate();
    if (result.isValid) {
      this.handleSubmit(event);
    }
  }

  handleAbort(): void {
    this.onAbort.emit();
  }

  handleSubmit(e: any): void {
    this.contactService.addPerson({ PersonItems: [this.formData] }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.onSubmit.emit({ data: result.personItems[0] });
          this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
        }
      },
      (error: any) => AppGlobals.ShowErrorMessage(error)
    );
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    this.type = type;
    this.message = e.feedback;
    this.toastVisible = true;
  }

  getCountriesByLanguage(): void {
    this.gridConnectionService.getCountries({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else this.countriesByLanguageList = result.countryList;
      },
      (error: any) => AppGlobals.ShowErrorMessage(error)
    );
  }

  handleCountryChange(e: any): void {}
}
